import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { Trans } from '../../Trans';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class SteeringFrameRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr={'Produktlinienbild'}/></td>
            <AttributeCell product={product} attr="Walzenlaenge_wM">
                <h4><Trans>Walzenlänge</Trans></h4>
                {this.getMinMaxLength(product)}
            </AttributeCell>
            <AttributeCell product={product} attr="Max_Materialspannung_wM"/>
            <AttributeCell product={product} attr="Max_Materialgeschwindigkeit_wM"/>
            <AttributeCell product={product} attr="Freitext_Drehrahmen_Aktoren"/>
            <AttributeCell product={product} attr="Regelungsart" extra={true}/>
            <AttributeCell product={product} attr="@parent.name" extra={true}/>
            <MiscCell product={product}/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={5} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }

    protected getMinMaxLength(product: ProductInterface): string | null {
        if (!product.children) {
            return null;
        }

        const bounds = AttributeUtility.getBounds(product.children, 'Walzenlaenge_wM');
        if (bounds) {
            return bounds.min + ' - ' + bounds.max;
        } else {
            return null;
        }
    }
}
